// @flow

import type {TabName} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {pick, pipe, prop} from 'ramda'
import {uiActions} from '@/store'

import HomePage from '@/views/home-page'
import PortfoliosPage from '@/views/portfolios-page'
import SettingsPage from '@/views/settings-page'
import ExportsPage from '@/views/exports-page'
import AnalysisPage from '@/views/analysis-page'
import BasicPage from '@/views/basic-page'
import Nav from '@/controls/nav'

type Props = {
  activeTab: TabName,
  setActiveTab: (string) => void,
}

const renderPage = (tabName: TabName) => {
  switch (tabName) {
    case 'home':
      return <HomePage />
    case 'portfolios':
      return <PortfoliosPage />
    case 'settings':
      return <SettingsPage />
    case 'exports':
      return <ExportsPage />
    case 'analysis':
      return <AnalysisPage />
    default:
      return <HomePage />
  }
}

export const RawTabbedView = ({activeTab, setActiveTab}: Props) =>
  <div>
    <Nav activeTab={activeTab} handleTabChange={setActiveTab} />
    <BasicPage>{renderPage(activeTab)}</BasicPage>
  </div>

const mapStateToProps = pipe(
  prop('ui'),
  pick(['activeTab']),
)

export default connect(
  mapStateToProps,
  uiActions,
)(RawTabbedView)



// WEBPACK FOOTER //
// ./src/views/tabbed-content/index.js